import { cfgBaseCurrencySymbol, cfgMegajackpotFeed } from '@infinitro/config';
export const defaultJackpotCurrency = {
    prefix: '$',
    suffix: '',
    grouping: ',',
    decimal: '.',
    precision: 1
};
const currencyCodeToPrefix = (code) => {
    try {
        return new Intl.NumberFormat('en', { style: 'currency', currency: code })
            .formatToParts(1)
            .find((part) => part.type === 'currency')?.value;
    }
    catch {
        return undefined;
    }
};
export const getJackpotCurrencySetting = () => {
    const currencyCode = cfgMegajackpotFeed()?.currency;
    const prefix = (currencyCode && currencyCodeToPrefix(currencyCode)) ||
        cfgBaseCurrencySymbol() ||
        defaultJackpotCurrency.prefix;
    return {
        ...defaultJackpotCurrency,
        prefix
    };
};
function unicodeToChar(text) {
    return text.replace(/\\u([\dA-F]{4})/gi, (_, charCode) => String.fromCharCode(parseInt(charCode, 16)));
}
export function formatJackpotCurrency(value, currency = defaultJackpotCurrency) {
    const prefix = unicodeToChar(currency.prefix);
    const suffix = unicodeToChar(currency.suffix);
    const grouping = unicodeToChar(currency.grouping);
    const decimal = unicodeToChar(currency.decimal);
    const { precision } = currency;
    const p2l = {
        1: 0,
        100: 2,
        100000: 5
    };
    const isNegative = value < 0;
    const internalNumber = Math.abs(value).toString().padStart(3, '0');
    const showKilo = precision === 100000 && internalNumber.length >= 6;
    const prec = showKilo ? p2l[precision] : 2;
    const str = internalNumber.substring(0, internalNumber.length - prec);
    const decimals = internalNumber.substr(internalNumber.length - prec, 2);
    let i = str.length;
    let result = '';
    while ((i -= 3) > 0) {
        result = `${grouping}${str.substr(i, 3)}${result}`;
    }
    return `${isNegative ? '-' : ''}${prefix}${str.substr(0, i + 3)}${result}${decimals === '00' ? '' : decimal + decimals}${showKilo ? 'k' : ''}${suffix}`;
}
